import NextLink from "next/link";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { LinkProps } from "./types";

function Link({ className, ...props }: LinkProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return <NextLink className={cn(className, classes)} {...native} />;
}

Link.displayName = "Link";

export default Link;
